import { IntlShape } from 'react-intl';

export type ProdLink = {
    label: string;
    url: string;
    active?: boolean;
    sup?: ReactNode;
};

export const products = {
    braiinsCom: {
        label: 'Braiins.com',
        url: 'https://braiins.com/?utm_source=BraiinsAcademy',
    } as ProdLink,
    braiinsPool: {
        label: 'Braiins Pool',
        url: 'https://braiins.com/pool?utm_source=BraiinsAcademy',
    } as ProdLink,
    braiinsManager: {
        label: 'Braiins Manager',
        url: 'https://braiins.com/manager',
        sup: 'New',
    } as ProdLink,
    braiinsOS: {
        label: 'Braiins\xa0OS',
        url: 'https://braiins.com/os-firmware?utm_source=BraiinsAcademy',
    } as ProdLink,
    farmProxy: {
        label: 'Farm Proxy',
        url: 'https://braiins.com/farm-proxy?utm_source=BraiinsAcademy',
    } as ProdLink,
    toolbox: {
        label: 'Toolbox',
        url: 'https://braiins.com/toolbox/?utm_source=BraiinsAcademy',
    } as ProdLink,
    miningInsights: {
        label: 'Mining Insights',
        url: 'https://insights.braiins.com/?utm_source=BraiinsAcademy',
    } as ProdLink,
};
export const allProducts: Array<ProdLink> = [
    products.braiinsCom,
    products.braiinsPool,
    products.braiinsManager,
    products.braiinsOS,
    products.toolbox,
    products.miningInsights,
    products.farmProxy,
];

export const external = {
    braiins: 'https://braiins.com/',
    telegram: 'https://t.me/Braiins',
    support: 'https://help.braiins.com/en/support/tickets/new',
};

export type GenericLink = {
    label: NonNullable<ReactNode>;
    url: string;
    external?: boolean;
};

export const about = ({ formatMessage }: IntlShape) => ({
    productUpdates: {
        url: 'https://braiins.com/category/product-updates',
        label: formatMessage({ defaultMessage: 'Product Updates' }),
        external: true,
    } as GenericLink,
    blog: {
        url: 'https://braiins.com/blog',
        label: formatMessage({ defaultMessage: 'Blog' }),
        external: true,
    } as GenericLink,
    designLang: {
        url: 'https://design.braiins.com/',
        label: formatMessage({ defaultMessage: 'Braiins Design Language' }),
        external: true,
    } as GenericLink,
});
export function allAbout(intl: IntlShape): Array<GenericLink> {
    const $ = about(intl);
    return [$.productUpdates, $.blog, $.designLang];
}

export function legal({ formatMessage, locale }: IntlShape) {
    return {
        termsAndConditions: {
            url: `/${locale}/terms-and-policies`,
            label: formatMessage({ defaultMessage: 'Terms & Policies' }),
        },
        contact: {
            external: true,
            url: `https://help.braiins.com/${locale}/support/tickets/new`,
            label: formatMessage({ defaultMessage: 'Contact' }),
        },
    } satisfies Record<string, GenericLink>;
}
export function allLegal(intl: IntlShape): Array<GenericLink> {
    const $ = legal(intl);
    return [$.termsAndConditions, $.contact];
}
